/** Kalendertage als ISO-Text (JJJJ-MM-TT), gerechnet ohne Zeitzonen-Sprünge. */
export function plusTage(iso: string, n: number): string {
  const d = new Date(`${iso}T00:00:00Z`)
  d.setUTCDate(d.getUTCDate() + n)
  return d.toISOString().slice(0, 10)
}

/** Kalenderwoche nach ISO 8601 (Woche mit dem ersten Donnerstag ist KW 1). */
export function kw(iso: string): number {
  const d = new Date(`${iso}T00:00:00Z`)
  d.setUTCDate(d.getUTCDate() + 3 - ((d.getUTCDay() + 6) % 7))
  const ersterDonnerstag = new Date(Date.UTC(d.getUTCFullYear(), 0, 4))
  return 1 + Math.round(((d.getTime() - ersterDonnerstag.getTime()) / 86_400_000 - 3 + ((ersterDonnerstag.getUTCDay() + 6) % 7)) / 7)
}

export const istIsoTag = (text: string | null): text is string => !!text && /^\d{4}-\d{2}-\d{2}$/.test(text)

const lokal = (iso: string) => new Date(`${iso}T00:00:00`)
export const kurz = (iso: string) => lokal(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" })
export const wochentag = (iso: string) => lokal(iso).toLocaleDateString("de-DE", { weekday: "short" }).replace(".", "")
export const langesDatum = (iso: string) =>
  lokal(iso).toLocaleDateString("de-DE", { weekday: "long", day: "2-digit", month: "2-digit", year: "numeric" })
